import { Image as ImageIcon, ExternalLink, FileText } from "lucide-react";

const POSTERS = [
  {
    id: "quickpitch-hard-shell",
    name: "Quick Pitch Hard Shell Roof Tent",
    size: "A0",
    aspect: "210/297",
    preview: "/posters/quickpitch-expo-poster-A2.jpg",
    full: "/posters/quickpitch-expo-poster-A0.jpg",
    pdf: "/posters/quickpitch-expo-poster-A0.pdf",
  },
  {
    id: "quickpitch-nyumba",
    name: "Quick Pitch Nyumba (Side Opening)",
    size: "A0",
    aspect: "210/297",
    preview: "/posters/quickpitch-nyumba-expo-poster-A2.jpg",
    full: "/posters/quickpitch-nyumba-expo-poster-A0.jpg",
    pdf: "/posters/quickpitch-nyumba-expo-poster-A0.pdf",
  },
  {
    id: "eezi-awn-galaxy",
    name: "EEZI-AWN Galaxy (Hybrid)",
    size: "A0",
    aspect: "210/297",
    preview: "/posters/eezi-awn-galaxy-expo-poster-A2.jpg",
    full: "/posters/eezi-awn-galaxy-expo-poster-A0.jpg",
    pdf: "/posters/eezi-awn-galaxy-expo-poster-A0.pdf",
  },
  {
    id: "quickpitch-awning",
    name: "Quick Pitch 270 Awning",
    size: "A0",
    aspect: "210/297",
    preview: "/posters/awning-expo-poster-A2.jpg",
    full: "/posters/awning-expo-poster-A0.jpg",
    pdf: "/posters/awning-expo-poster-A0.pdf",
  },
  {
    id: "bushcabin",
    name: "Bushtech Bush Cabin",
    size: "A0",
    aspect: "210/297",
    preview: "/posters/bushcabin-expo-poster-A0.jpg",
    full: "/posters/bushcabin-expo-poster-A0.jpg",
    pdf: "/posters/bushcabin-expo-poster-A0.pdf",
  },
  {
    id: "bushcabin-banner",
    name: "Bushtech Bush Cabin (Landscape Banner)",
    size: "880 x 380mm",
    aspect: "880/380",
    preview: "/posters/bushcabin-banner-880x380.jpg",
    full: "/posters/bushcabin-banner-880x380.jpg",
    pdf: "/posters/bushcabin-banner-880x380.pdf",
  },
  {
    id: "bushcabin-a3-landscape",
    name: "Bushtech Bush Cabin (A3 Landscape)",
    size: "A3 Landscape",
    aspect: "420/297",
    preview: "/posters/bushcabin-poster-A3-landscape.jpg",
    full: "/posters/bushcabin-poster-A3-landscape.jpg",
    pdf: "/posters/bushcabin-poster-A3-landscape.pdf",
  },
];

export default function AdminPostersPage() {
  return (
    <div data-testid="admin-posters-page">
      <div className="flex items-center gap-2 mb-2">
        <ImageIcon size={20} className="text-[var(--brand-primary)]" />
        <h1 className="font-display text-3xl text-white">Expo Posters</h1>
      </div>
      <p className="text-white/50 text-sm font-mono mb-8">
        One print-ready PDF per poster, sized at A0 — printers can scale it down to A2 or any smaller size with zero quality loss.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {POSTERS.map((poster) => (
          <div
            key={poster.id}
            data-testid={`admin-poster-card-${poster.id}`}
            className="border border-[var(--border-default)] bg-[var(--bg-secondary)] overflow-hidden"
          >
            <a href={poster.full} target="_blank" rel="noopener noreferrer" data-testid={`admin-poster-thumb-${poster.id}`}>
              <img src={poster.preview} alt={poster.name} loading="lazy" style={{ aspectRatio: poster.aspect }} className="w-full object-cover object-top hover:opacity-80 transition-opacity" />
            </a>
            <div className="p-4">
              <h2 className="font-display text-lg text-white mb-1">{poster.name}</h2>
              <p className="text-white/40 text-xs font-mono uppercase tracking-widest mb-3">{poster.size}</p>
              <div className="flex flex-wrap gap-2">
                <a
                  href={poster.full}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`admin-poster-view-${poster.id}`}
                  className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-widest text-white/70 border border-[var(--border-default)] px-3 py-1.5 hover:text-[var(--brand-primary)] hover:border-[var(--brand-primary)]/40 transition-colors"
                >
                  <ExternalLink size={12} /> View Full Size
                </a>
                <a
                  href={poster.pdf}
                  download
                  data-testid={`admin-poster-download-pdf-${poster.id}`}
                  className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-widest text-[var(--brand-primary)] border border-[var(--brand-primary)]/40 px-3 py-1.5 hover:bg-[var(--brand-primary)]/10 transition-colors"
                >
                  <FileText size={12} /> Download Print PDF
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
